// extracted by css-extract-rspack-plugin
export default {"cls1":"CoScientistLandingPage-cls1_KzO","cls2":"CoScientistLandingPage-cls2_pfJ CoScientistLandingPage-cls1_KzO"};